import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export interface UpdateUserPlanPayload {
	id: string;
	plan: string;
}

export const useUpdateUserPlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, plan }: UpdateUserPlanPayload) => {
			try {
				return (await api.put(`/management/user/updatePlan/${id}`, { plan })).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar plano do usuário');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['users'] });
			queryClient.invalidateQueries({ queryKey: ['userId', variables.id] });
		},
		onError: error => console.error('Erro ao atualizar plano do usuário:', getApiErrorMessage(error, 'Erro ao atualizar plano do usuário')),
	});
};
